import { Forms } from '../../components/Forms'
import { FloatFooter } from '../../components/FloatFooter/FloatFooter'
import { BTN_TXT } from '../../constants'
import { useCallback, useState } from 'react'
import { initialState } from './constants'
import { TAddGopForm } from './types'

export const AddGpoForm = ({
  form,
  details,
  isEdit,
  isGeneral
}: TAddGopForm) => {
  const [isActive, setIsActive] = useState(false)
  const submitCancellation = () => {
    handleCancelForm()
  }

  const handleCancelForm = useCallback(() => {
    setIsActive(false)
    if (isEdit) {
      form.setFieldsValue(details)
    } else {
      form.setFieldsValue(initialState)
    }
    if (!isGeneral) {
      history.back()
    }
  }, [form, setIsActive, details, isEdit, isGeneral])
  return (
    <>
      <div>
        <Forms.GpoDetails form={form} setIsActive={setIsActive} />
      </div>
      <FloatFooter
        isActive={isActive}
        onCancel={submitCancellation}
        onSave={form.submit}
        isSaveDisabled={!isActive}
        saveBtnText={BTN_TXT.SAVE}
      />
    </>
  )
}
